import { TwinManagementSettings } from "./../components/twinManagement/types";
export const clientId = "smx-knowledge-spaces";

export const knowledgeDocumentCategory = "knowledgeDocument";

export const knowledgeUnitTypes = {
  document: "document",
  twin: "twin",
};

export const unitStatuses = {
  done: "done",
  error: "error",
  processing: "processing",
};

export const spaceRoles = {
  owner: "owner",
  member: "member",
  steward: "steward",
};

export const twinManagementSettings: TwinManagementSettings = {
  prefix: "knowledge.*",
  label: "knowledgeEntries",
  baseRoute: "ksUnitTypeSelection",
  listViewName: "ksTwinsList",
  detailViewName: "ksTwinDetail",
  hideQrCode: true,
  hideBatchCreate: true,
};

export const roles = {
  user: "user",
  admin: "admin",
  steward: "steward",
};
